export default __webpack_public_path__ + "static/media/money-back.48257e2a.png";